import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleIcon, MicrosoftIcon, AppleIcon, SlackIcon } from './AuthIcons';
export function SignUp() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleEmailSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Store email temporarily - actual signup happens in Register component
      sessionStorage.setItem('signupEmail', email);
      // Navigate to register page
      navigate('/register', {
        state: {
          email
        }
      });
    } catch (error) {
      console.error('Error signing up:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSocialSignUp = async (provider: string) => {
    setIsLoading(true);
    try {
      // Store social provider email temporarily
      const socialEmail = `user@${provider.toLowerCase()}.com`;
      sessionStorage.setItem('signupEmail', socialEmail);
      sessionStorage.setItem('signupProvider', provider);
      // Navigate to register page
      navigate('/register', {
        state: {
          email: socialEmail,
          provider
        }
      });
    } catch (error) {
      console.error('Error with social sign up:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSignIn = () => {
    // Redirect to a sign-in page or handle sign-in logic
    navigate('/signin');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-226">
    <div className="max-w-md w-full" data-id="element-227">
      <div className="text-center mb-10" data-id="element-228">
        <h1 className="text-4xl font-bold mb-2" data-id="element-229">SignUp</h1>
        <p className="text-gray-600" data-id="element-230">
          Join the MGA Portal for feasibility study
        </p>
      </div>
      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-231">
        <div className="mb-8" data-id="element-232">
          <h2 className="text-2xl font-semibold mb-6" data-id="element-233">Create your account</h2>
          <form onSubmit={handleEmailSignUp} data-id="element-234">
            <div className="mb-4" data-id="element-235">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-236">
                Work email
              </label>
              <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" className="w-full p-3 border border-gray-300 rounded-md" required data-id="element-237" />
            </div>
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition duration-150 ease-in-out" disabled={isLoading} data-id="element-238">
              {isLoading ? 'Processing...' : 'Sign up'}
            </button>
          </form>
        </div>
        <div className="relative mb-6" data-id="element-239">
          <div className="absolute inset-0 flex items-center" data-id="element-240">
            <div className="w-full border-t border-gray-300" data-id="element-241"></div>
          </div>
          <div className="relative flex justify-center text-sm" data-id="element-242">
            <span className="px-2 bg-white text-gray-500" data-id="element-243">
              Or continue with
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3" data-id="element-244">
          <button onClick={() => handleSocialSignUp('google')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-245">
            <GoogleIcon data-id="element-246" />
          </button>
          <button onClick={() => handleSocialSignUp('microsoft')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-247">
            <MicrosoftIcon data-id="element-248" />
          </button>
          <button onClick={() => handleSocialSignUp('apple')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-249">
            <AppleIcon data-id="element-250" />
          </button>
          <button onClick={() => handleSocialSignUp('slack')} className="flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md hover:bg-gray-50 transition duration-150" data-id="element-251">
            <SlackIcon data-id="element-252" />
          </button>
        </div>
      </div>
      <div className="text-center" data-id="element-253">
        <p className="text-gray-600" data-id="element-254">
          Already have an account?{' '}
          <button onClick={handleSignIn} className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-255">
            Sign in
          </button>
        </p>
      </div>
    </div>
  </div>;
}